import type { FC } from "react";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useTranslations } from "@jti/ui";

type AgeVerificationMessageBoxProps = { isVisible: boolean };

export const AgeVerificationMessageBox: FC<AgeVerificationMessageBoxProps> = ({ isVisible }) => {
  const { __ } = useTranslations();

  return isVisible ? (
    <AlertBanner tone="warning" description={__("libs.ui.notification.limit.age_verification")} />
  ) : null;
};
